<template>
  <div>
    <v-alert
      color="primary"
      dark
      class="mx-4 mt-4 rounded-lg"
      icon="mdi-store-outline"
    >
      <v-row align="center" no-gutters>
        <v-col>
          <div class="text-subtitle-1 font-weight-bold">{{ $t('guest.registerCta') }}</div>
          <div class="text-body-2">{{ $t('guest.registerCtaDesc') }}</div>
        </v-col>
        <v-col cols="auto" class="ml-4">
          <v-btn
            outlined
            color="white"
            :loading="registerLoading"
            @click="goToRegister"
          >
            {{ $t('guest.registerBtn') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <v-card class="pa-0 pb-10 mt-4" tile>
      <v-card-title>
        <h4 class="primary--text">{{ $t('guest.settings') }}</h4>
      </v-card-title>
      <div class="background px-6">
        <v-tabs v-model="tab" :height="60" background-color="background" show-arrows hide-slider center-active>
          <v-tab>{{ $t('guest.tabs.personalInfo') }}</v-tab>
          <v-tab>{{ $t('guest.tabs.companyData') }}</v-tab>
          <v-tab>{{ $t('guest.tabs.notifications') }}</v-tab>
          <v-tab>{{ $t('guest.tabs.password') }}</v-tab>
        </v-tabs>
      </div>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <GuestPersonalInfo />
        </v-tab-item>
        <v-tab-item>
          <GuestCompanyData />
        </v-tab-item>
        <v-tab-item>
          <GuestNotifications />
        </v-tab-item>
        <v-tab-item>
          <div class="pa-6">
            <v-row>
              <v-col cols="12" md="6">
                <ChangePasswordCard />
              </v-col>
            </v-row>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import GuestPersonalInfo from './tabs/GuestPersonalInfo.vue'
import GuestCompanyData from './tabs/GuestCompanyData.vue'
import GuestNotifications from './tabs/GuestNotifications.vue'
import ChangePasswordCard from '@/components/cards/ChangePasswordCard.vue'
import { getGuestProfile } from '@/services/guest'

export default {
  name: 'GuestSettings',
  components: {
    GuestPersonalInfo,
    GuestCompanyData,
    GuestNotifications,
    ChangePasswordCard
  },
  data () {
    return {
      tab: null,
      registerLoading: false
    }
  },
  methods: {
    async goToRegister () {
      this.registerLoading = true
      try {
        const { data } = await getGuestProfile()
        localStorage.setItem('guestPrefill', JSON.stringify({
          company: {
            VatNumber: data.vatNumber,
            CompanyName: data.companyName,
            Street: data.street,
            ZipCode: data.zipCode,
            City: data.city,
            Country: data.country
          },
          personal: {
            userName: data.firstName,
            surname: data.lastName,
            email: data.email,
            phoneNumber: data.phone,
            language: data.language || ''
          }
        }))
      } catch (e) {}
      const registerRoute = this.$router.resolve({ name: 'Register' })
      window.open(registerRoute.href, '_blank')
      // await this.$store.dispatch('clearSession')
      this.registerLoading = false
    }
  }
}
</script>
